import React, {Component} from 'react';

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap-select'
import "bootstrap-select/dist/css/bootstrap-select.min.css";

import 'datatables.net-dt'
import 'datatables.net-dt/css/dataTables.dataTables.min.css'
import 'datatables.net-fixedcolumns-dt'
import 'datatables.net-fixedcolumns-dt/css/fixedColumns.dataTables.min.css'
import 'datatables.net-scroller-dt'
import 'datatables.net-scroller-dt/css/scroller.dataTables.min.css'
import 'datatables.net-select-dt'
import 'datatables.net-select-dt/css/select.dataTables.min.css'

import JSZip from 'jszip';
import 'pdfmake';
import 'datatables.net-buttons-dt'
import 'datatables.net-buttons/js/buttons.html5'
import 'datatables.net-buttons/js/buttons.print'
import 'datatables.net-buttons/js/buttons.colVis'
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css'

import Cookies from 'universal-cookie';

import MultiDayTradesTbl from './tables/MultiDayTradesTbl.js'
import SyblTbl from './tables/SyblTbl.js'
import TotalTbl from './tables/TotalTbl.js'
import AcctTbl from './tables/AcctTbl.js'
import TopSymbolTbl from './tables/TopSymbolTbl.js'
import TopAcctTbl from './tables/TopAcctTbl.js'
import TopMVTbl from './tables/TopMVTbl.js'
import TagTbl from './tables/TagTbl.js'
import TagGroupTbl from './tables/TagGroupTbl.js'
import GroupedTbl from './tables/GroupedTbl.js'

import FirmFilter from './filters/FirmFilter.js'
import AcctFilter from './filters/AcctFilter.js'
import SyblFilter from './filters/SyblFilter.js'
import TagFilter from './filters/TagFilter.js'
import AggFilter from './filters/AggFilter.js'

import Badges from './filters/Badges.js'

import Graph from './graph/Graph.js'
import AnalyticsGraph from './graph/AnalyticsGraph.js'
import GroupedGraph from './graph/GroupedGraph.js'
import MultiDayGraph from './graph/MultiDayGraph.js'

import {MWBaseURL, GetESTDateString} from './Utilities.js'
import { createApiClient } from './api/ApiClient.js';

import './App.css';
import './graph/Graph.css';

window.JSZip = JSZip;

function GroupLayout(props){
	let viewName = "Top/Bottom"
	if(props.state.view === 1){
		viewName = "Symbols"
	}
	else if(props.state.view === 2){
		viewName = "Traders"
	}
	return (
		<div>
			<div className="form-row align-items-center nav nav-tabs pt-3 mb-2">
				<div className="col-auto">
					<div className="input-group">
						{props.state.view !== 0 && <div className="input-group-prepend">
							<button className="btn btn-outline-secondary clear-btn" type="button" onClick={() => props.refilter({view: 0, selectedAcct: [], selectedTag: [], selectedSybl: [], selectedx0: null, selectedx1: null, selectedRows: []})}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-house" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
									<path fillRule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
								</svg>
							</button>
						</div>}
						<button className="form-control btn btn-secondary">{viewName}</button>
						{props.state.view !== 0 && <div className="input-group-append">
							<button className="btn btn-outline-secondary clear-btn" type="button" onClick={() => props.refilter({view: props.getLastViewHist(), selectedAcct: [], selectedTag: [], selectedSybl: [], selectedx0: null, selectedx1: null, selectedRows: []})}>
								<img src="icon.png" alt="X"/>
							</button>
						</div>}
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xl-6 order-xl-1">
					<Graph height={(props.state.view === 0 ? "450" : "700")} date={props.state.selectedDate} start={props.state.selectedx0}
						end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
				</div>
				<div className="col-xl-6 order-xl-0">
					<TotalTbl date={props.state.selectedDate} start={props.state.selectedx0}
						end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
					{props.state.view === 0 && (
						<TopAcctTbl id="topAcctTbl" date={props.state.selectedDate} start={props.state.selectedx0}
							end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
							startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
					)}
					{props.state.view === 1 && (
						<SyblTbl title="Symbols" selectMode={1} height="600" date={props.state.selectedDate} start={props.state.selectedx0} end={props.state.selectedx1}
							firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
							startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount}
							auth={props.state.auth} lastSelectedTbl={props.state.lastSelectedTbl}/>
					)}
					{props.state.view === 2 && (
						<AcctTbl date={props.state.selectedDate} start={props.state.selectedx0}
							end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
							startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount}
							auth={props.state.auth} lastSelectedTbl={props.state.lastSelectedTbl}/>
					)}
				</div>
			</div>
			{props.state.view === 0 && (<div className="row">
				<div className="col-xl-6">
					<TopSymbolTbl id="pnlSymbolTbl" date={props.state.selectedDate} start={props.state.selectedx0}
						end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
				</div>
				<div className="col-xl-6">
					<TopMVTbl id="topMVTbl" date={props.state.selectedDate} start={props.state.selectedx0}
						end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
				</div>
			</div>)}
		</div>
	)
}

function TraderLayout(props){
	return (
		<div>
			<div className="form-row align-items-center nav nav-tabs pt-3 mb-2">
				<div className="col-auto">
					<div className="input-group">
						{props.state.auth.role && !props.state.auth.role.includes("TRADER") && <div className="input-group-prepend">
							<button className="btn btn-outline-secondary clear-btn" type="button" onClick={() => props.refilter({view: 0, selectedAcct: [], selectedTag: [], selectedSybl: [], selectedx0: null, selectedx1: null, selectedRows: []})}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-house" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
									<path fillRule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
								</svg>
							</button>
						</div>}
						<button onClick={() => props.refilter({view: 3, selectedx0: null, selectedx1: null, selectedRows: []})} className={"form-control btn" + (props.state.view === 3 ? " btn-secondary" : " btn-light")}>{(props.state.selectedAcctName ? props.state.selectedAcct[0] + ": " + props.state.selectedAcctName : "Trader")}</button>
						{props.state.auth.role && !props.state.auth.role.includes("TRADER") && <div className="input-group-append">
							<button className="btn btn-outline-secondary clear-btn" type="button" onClick={() => props.refilter({view: props.getLastViewHist(), selectedAcct: [], selectedTag: [], selectedSybl: [], selectedx0: null, selectedx1: null, selectedRows: []})}>
								<img src="icon.png" alt="X"/>
							</button>
						</div>}
					</div>
				</div>
				<div className="col-auto">
					<button onClick={() => props.refilter({view: 4, selectedx0: null, selectedx1: null, selectedRows: []})} className={"btn" + (props.state.view === 4 ? " btn-secondary" : " btn-light")}>Tags</button>
				</div>
				<div className="col-auto">
					<button onClick={() => props.refilter({view: 5, selectedx0: null, selectedx1: null, selectedRows: []})} className={"btn" + (props.state.view === 5 ? " btn-secondary" : " btn-light")}>Analytics</button>
				</div>
				<div className="col-auto">
					<button onClick={() => props.refilter({view: 7, selectedx0: null, selectedx1: null, selectedRows: []})} className={"btn" + (props.state.view === 7 ? " btn-secondary" : " btn-light")}>Trades</button>
				</div>
			</div>
			<div className="row mb-2">
				{[4, 5, 7].includes(props.state.view) && <div className="col-lg-4 col-md-6 col-sm-8 pt-1">
					<div className="input-group">
						<div className="input-group-prepend">
							<button type="button" onClick={e => props.refilter({selectedCustomDateRange: true})} className={"btn btn-"+(!props.state.selectedCustomDateRange ? "outline-secondary" : "secondary")}>Custom Range</button>
						</div>
						<div className="input-group-prepend">
							<button type="button" onClick={e => {props.updateRange("MTD");props.refilter({selectedCustomDateRange: false})}} className={"btn btn-"+(props.state.selectedCustomDateRange ? "outline-secondary" : "secondary")}>Range</button>
						</div>
						{!props.state.selectedCustomDateRange && <select className="form-control" onChange={(e) => props.updateRange(e.target.value)}>
							<option value="MTD">Month to Date</option>
							<option value="QTD">Quarter to Date</option>
							<option value="YTD">Year to Date</option>
							<option value="LY">Last Year</option>
						</select>}
						{props.state.selectedCustomDateRange && 
							<input type="date" className="form-control" value={props.state.selectedDateStart} onChange={(e) => {props.refilter({selectedDateStart: e.target.value})}} min="2012-01-01" max={props.state.selectedDateEnd}/>
						}
						{props.state.selectedCustomDateRange && 
							<input type="date" className="form-control" value={props.state.selectedDateEnd} onChange={(e) => {props.refilter({selectedDateEnd: e.target.value})}} min={props.state.selectedDateStart} max={GetESTDateString()}/>
						}
					</div>
				</div>}
				{[4, 5, 7].includes(props.state.view) && (<TagFilter date={props.state.selectedDateStart} dateEnd={props.state.selectedDateEnd} tag={props.state.selectedTag} tagAndMode={props.state.tagAndMode} acct={props.state.selectedAcct} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>)}
			</div>
			{props.state.view === 3 && <div className="row">
				<div className="col-xl-6 order-xl-1">
					<Graph height="800" date={props.state.selectedDate} start={props.state.selectedx0}
						end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
				</div>
				<div className="col-xl-6 order-xl-0">
					<TotalTbl date={props.state.selectedDate} start={props.state.selectedx0}
						end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
					<SyblTbl title="Daily Activities" selectMode={0} date={props.state.selectedDate} start={props.state.selectedx0} end={props.state.selectedx1}
						firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
					<MultiDayTradesTbl height="280" autoUpdate={true} date={props.state.selectedDate} dateEnd={props.state.selectedDate} start={props.state.selectedx0} end={props.state.selectedx1}
						firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth} selectedRows={props.state.selectedRows}/>
				</div>
			</div>}
			{props.state.view === 4 && <div className="row">
				{props.state.selectedRows.length === 1 &&
					<div className="col-xl-6 order-xl-1">
						<Graph height="800" date={props.state.selectedRows[0].fdate} start={props.state.selectedx0}
							end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={[props.state.selectedRows[0].symbol]}
							refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
					</div>
				}
				<div className="col-xl-6 order-xl-0">
					<TagTbl date={props.state.selectedDateStart} dateEnd={props.state.selectedDateEnd} start={props.state.selectedx0} end={props.state.selectedx1}
						firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl} tag={props.state.selectedTag} tagAndMode={props.state.tagAndMode}
						refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth} selectedRows={props.state.selectedRows}/>
				</div>
			</div>}
			{props.state.view === 5 && <div className="row">
				{props.state.selectedRows.length === 1 &&
					<div className="col-xl-6 order-xl-1">
						<AnalyticsGraph height="600" date={props.state.selectedDateStart} dateEnd={props.state.selectedDateEnd} start={props.state.selectedx0}
							end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl} tag={(props.state.tagAndMode ? props.state.selectedTag :[props.state.selectedRows[0].tag])} tagAndMode={props.state.tagAndMode}
							refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth} selectedRows={props.state.selectedRows}/>
					</div>
				}
				<div className="col-xl-6 order-xl-0">
					<TagGroupTbl date={props.state.selectedDateStart} dateEnd={props.state.selectedDateEnd} start={props.state.selectedx0} end={props.state.selectedx1}
						firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl} tag={props.state.selectedTag} tagAndMode={props.state.tagAndMode}
						refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth} selectedRows={props.state.selectedRows}/>
				</div>
			</div>}
			{props.state.view === 7 && <div className="row">
				{props.state.selectedRows.length === 1 &&
					<div className="col-xl-6 order-xl-1">
						<Graph height="800" date={(props.state.selectedRows[0].end || "").substring(0, 10)}
							start={((props.state.selectedRows[0].start || "").substring(0, 10) === (props.state.selectedRows[0].end || "").substring(0, 10) ? props.state.selectedx0 : (props.state.selectedRows[0].end || "").substring(0, 11)+"00:00:00")}
							end={props.state.selectedx1} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={[props.state.selectedRows[0].symbol]}
							refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth}/>
					</div>
				}
				{props.state.selectedRows.length > 1 && !Array.from(props.state.selectedRows, x => x.end).includes(null) && 
					<div className="col-xl-6 order-xl-1">
						<MultiDayGraph height="600" acct={props.state.selectedAcct} refilter={props.refilter} auth={props.state.auth} selectedRows={props.state.selectedRows}/>
					</div>
				}
				<div className="col-xl-6 order-xl-0">
					<MultiDayTradesTbl height="600" updateSymbols={true} date={props.state.selectedDateStart} dateEnd={props.state.selectedDateEnd} start={props.state.selectedx0} end={props.state.selectedx1}
						firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl} tag={props.state.selectedTag} tagAndMode={props.state.tagAndMode}
						startTS={props.state.tsTimeS} endTS={props.state.tsTimeE} refilter={props.refilter} updateCount={props.state.updateCount} auth={props.state.auth} selectedRows={props.state.selectedRows}/>
				</div>
			</div>}
		</div>
	)
}

function AggGroupLayout(props){
	return (
		<div className="pt-3">
			<div className="row">
				<div className="col-xl-12">
					<GroupedGraph height="400" group={props.state.group} agg={props.state.agg} grpData={props.state.grpData} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl} auth={props.state.auth} refilter={props.refilter} groupChange={props.groupChange}/>
				</div>
			</div>
			<div className="row">
				<div className="col-xl-12">
					<GroupedTbl group={props.state.group} agg={props.state.agg} grpData={props.state.grpData} firm={props.state.selectedFirm} acct={props.state.selectedAcct} sybl={props.state.selectedSybl} auth={props.state.auth} groupChange={props.groupChange}/>
				</div>
			</div>
		</div>
	)
}

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedDate: null,
			selectedDateStart: null,
			selectedCustomDateRange: false,
			selectedDateEnd: null,
			selectedFirm: ["Trillium Trading"],
			selectedAcct: [],
			selectedAcctName: null,
			selectedSybl: [],
			selectedx0: null,
			selectedx1: null,
			selectedTag: [],
			tagAndMode: false,

			selectedRows: [],

			tsTimeS: null,
			tsTimeE: null,

			updateCount: 0,

			loggedIn: false,
			initAuth: false,
			auth: {},

			lastSelectedTbl: null,

			view: 3,//0->top/bottom, 1-> all symbols, 2-> all traders, 3->trader, 4-> tags, 5-> analytics, 6-> group, 7-> trades
			viewHistory: [],

			group: null,
			agg: null,
			grpData: []
		}
	}

	handleDateStartChange = date => {
		if(date){
			this.setState({
				selectedDateStart: GetESTDateString(date),
				selectedx0: null,
				selectedx1: null
			})
		}
	}

	handleDateEndChange = date => {
		if(date){
			this.setState({
				selectedDateEnd: GetESTDateString(date),
				selectedx0: null,
				selectedx1: null
			})
		}
	}

	updateRange = (v) => {
		let newStartDate, newEndDate;
		if(v === "MTD"){
			newEndDate = new Date()
			newStartDate = new Date(newEndDate.getFullYear(), newEndDate.getMonth(), 1)
		}else if(v === "QTD"){
			newEndDate = new Date()
			newStartDate = new Date(newEndDate.getFullYear(), newEndDate.getMonth() - (newEndDate.getMonth() % 3), 1)
		}else if(v === "YTD"){
			newEndDate = new Date()
			newStartDate = new Date(newEndDate.getFullYear(), 0, 1)
		}else if(v === "LY"){
			newEndDate = new Date((new Date()).getFullYear() - 1, 11, 31)
			newStartDate = new Date((new Date()).getFullYear() - 1, 0, 1)
		}
		this.setState({selectedDateStart: GetESTDateString(newStartDate), selectedDateEnd: GetESTDateString(newEndDate)})
	}
	
	groupChange = (tier, group) => {
		let obj = {selectedx0: null, selectedx1: null, selectedRows: []}
		if(!group && !isNaN(tier)){// Truncate date to group level
			obj.group = this.state.group.split("-", tier).join("-")
			obj.view = 6
		}else if(group.length < 10){// Set part date
			obj.view = 6
			obj.group = group
		}else{// Set full date
			if(this.state.auth.role.includes("TRADER") || (this.state.selectedAcct && this.state.selectedAcct.length === 1)){
				obj.view = 3
			}else if(this.state.selectedSybl && this.state.selectedSybl.length === 1){
				obj.view = 2
			}else{
				obj.view = 0
			}
			obj.selectedDate = group
			obj.group = group
		}
		switch(obj.group && obj.group.split("-").length){
			case 2:
				obj.agg = "DAY"
				break;
			case 1:
				obj.agg = "MONTH"
				break;
			default:
				obj.agg = "YEAR"
				break;
		}

		this.setState(obj)
	}

	addViewHist = v => {
		if(!this.state.viewHistory.length || this.state.viewHistory[0] !== this.state.view){
			this.setState({"viewHistory": (this.state.view === 0 ? [0] : [this.state.view, ...this.state.viewHistory])})
		}
	}

	getLastViewHist = () => {
		let pastViews = [...this.state.viewHistory.slice(1)]
		let i = pastViews.findIndex(e => e < 3 && e !== this.state.viewHistory[0])
		pastViews = [...pastViews.slice(i)]

		let lastView = (i === -1 ? 0 : pastViews[0])

		this.setState({"viewHistory": pastViews})
		return lastView
	}

	updateAfterFilterUpdate = (obj) => {
		if(this.state.view !== 6){
			if(obj.selectedAcct && obj.selectedAcct.length === 1 && ![3, 4, 5].includes(this.state.view)){
				obj.view = 3
			}else if(obj.selectedSybl && obj.selectedSybl.length === 1 && this.state.selectedAcct.length !== 1 && ![2].includes(this.state.view)){
				if(this.state.auth.role && !this.state.auth.role.includes("TRADER")){
					obj.view = 2
				}
			}else if(obj.selectedAcct && obj.selectedAcct.length !== 1 && [3, 4, 5].includes(this.state.view) && (!obj.view ||[3, 4, 5].includes(obj.view))){
				if(this.state.auth.role && !this.state.auth.role.includes("TRADER")){
					obj.view = 0
				}
			}
		}
		this.setState(obj, function(){
			if("view" in obj){
				this.addViewHist(this.state.view)
			}
		})
	}

	componentDidMount() {
		let self = this;

		function initialLoad(){

			setInterval(function() {

				if(self.state.selectedDate === GetESTDateString() && !self.state.selectedx1 && self.state.view !== 6){
					self.setState({updateCount: self.state.updateCount + 1})
				}
			}, 30000);
		}

		let params = new URLSearchParams(document.location.search)
		const cookies = new Cookies();
		let data = {}
		if(params.has("userid") && params.has("token")){
			data = {"user": params.get("userid"), "token": params.get("token")}
		}else if(cookies.get("user") && cookies.get("token")){
			data = {"user": cookies.get("user"), "token": cookies.get("token")}
		}
		const apiClient = createApiClient();
		let authResponse;
		apiClient.post(MWBaseURL()+"auth", data)
		.then(function(response){
			authResponse = response
			return apiClient.get(MWBaseURL()+"last_trading_date")
		})
		.then(function(response2){
			window.history.pushState(undefined, '', window.location.href.split('?')[0])
			cookies.set('user', authResponse.user, { path: '/' });
			cookies.set('token', authResponse.token, { path: '/' });
			let filterUpdates = {
				loggedIn: true,
				initAuth: true,
				auth: {
					user: authResponse.user,
					token: authResponse.token,
					role: authResponse.role,
					accounts: authResponse.accounts
				},
				group: response2[0]["day"],
				selectedDate: response2[0]["day"],
				view: (authResponse.role.includes("TRADER") ? 3 : 0)
			}
			if(!authResponse.role.includes("ADMIN")){
				filterUpdates.selectedFirm = []
			}
			self.updateAfterFilterUpdate(filterUpdates)
			self.updateRange("MTD")
			initialLoad()
		})
		.catch(e => self.setState({loggedIn: false, initAuth: true}))
	}

	render() {
		let crumb;
		switch(this.state.group && this.state.group.split("-").length){
			case 3://Day
				crumb = 
				<ol className="breadcrumb mb-0">
					<li className="breadcrumb-item" aria-current="page"><span className="fauxlink" onClick={() => this.groupChange(0)}>All</span></li>
					<li className="breadcrumb-item" aria-current="page"><span className="fauxlink" onClick={() => this.groupChange(1)}>{this.state.group.split("-")[0]}</span></li>
					<li className="breadcrumb-item" aria-current="page"><span className="fauxlink" onClick={() => this.groupChange(2)}>{this.state.group.split("-")[1]}</span></li>
					<li className="breadcrumb-item active" aria-current="page">{this.state.group.split("-")[2]}</li>
				</ol>
				break;
			case 2://Month
				crumb = 
				<ol className="breadcrumb mb-0">
					<li className="breadcrumb-item" aria-current="page"><span className="fauxlink" onClick={() => this.groupChange(0)}>All</span></li>
					<li className="breadcrumb-item" aria-current="page"><span className="fauxlink" onClick={() => this.groupChange(1)}>{this.state.group.split("-")[0]}</span></li>
					<li className="breadcrumb-item active" aria-current="page">{this.state.group.split("-")[1]}</li>
				</ol>
				break;
			case 1://Year
				crumb = 
				<ol className="breadcrumb mb-0">
					<li className="breadcrumb-item" aria-current="page"><span className="fauxlink" onClick={() => this.groupChange(0)}>All</span></li>
					<li className="breadcrumb-item active" aria-current="page">{this.state.group.split("-")[0]}</li>
				</ol>
				break;
			default:
				crumb =
				<ol className="breadcrumb mb-0">
					<li className="breadcrumb-item active" aria-current="page">All</li>
				</ol>
				break;
		}
		let threshhold = this.state.group && this.state.group.split("-").length
		return (
		<div className="container-fluid">
			<svg xmlns="http://www.w3.org/2000/svg" style={{display: "none"}}>
				<symbol id="download-icon" fill="currentColor" viewBox="0 0 16 16">
					<path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
					<path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
				</symbol>
				<symbol id="search-icon" fill="currentColor" viewBox="0 0 16 16">
					<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
				</symbol>
				<symbol id="clipboard-icon" fill="currentColor" viewBox="0 0 16 16">
					<path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
					<path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
				</symbol>
				<symbol id="collapse-icon" fill="currentColor" viewBox="0 0 16 16">
					<path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8m7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0m-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0z"/>
				</symbol>
				<symbol id="expand-icon" fill="currentColor" viewBox="0 0 16 16">
					<path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2M8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10"/>
				</symbol>
			</svg>
			{this.state.loggedIn && (<div>
				<div className="row">
					{![4, 5, 7].includes(this.state.view) && <nav className="col-lg-2 col-md-3 col-sm-4 pt-1" aria-label="breadcrumb">
						{crumb}
					</nav>}
					{this.state.auth.role && this.state.auth.role.includes("ADMIN") &&
						<FirmFilter firm={this.state.selectedFirm} refilter={this.updateAfterFilterUpdate} updateCount={this.state.updateCount} auth={this.state.auth}/>
					}
					{this.state.auth.role && (this.state.auth.role.includes("ADMIN") || this.state.auth.role.includes("GROUP")) &&
						<AcctFilter date={this.state.selectedDate} group={this.state.group} view={this.state.view} firm={this.state.selectedFirm} acct={this.state.selectedAcct} refilter={this.updateAfterFilterUpdate} updateCount={this.state.updateCount} auth={this.state.auth}/>
					}
					<SyblFilter date={([4, 5, 7].includes(this.state.view) ? this.state.selectedDateStart : this.state.selectedDate)}
						dateEnd={([4, 5, 7].includes(this.state.view) ? this.state.selectedDateEnd : this.state.selectedDate)} 
						group={this.state.group} view={this.state.view} sybl={this.state.selectedSybl} refilter={this.updateAfterFilterUpdate} updateCount={this.state.updateCount} auth={this.state.auth}/>
					
					{[6].includes(this.state.view) && <AggFilter agg={this.state.agg} threshhold={threshhold} refilter={this.updateAfterFilterUpdate}/>}
					{[3, 4, 5, 7].includes(this.state.view) && <Badges date={this.state.selectedDate} acct={this.state.selectedAcct} auth={this.state.auth}/>}
				</div>
				{[0, 1, 2].includes(this.state.view) && <GroupLayout state={this.state} graphLayout={this.graphLayout} refilter={this.updateAfterFilterUpdate} getLastViewHist={this.getLastViewHist}/>}
				{[3, 4, 5, 7].includes(this.state.view) && <TraderLayout state={this.state} graphLayout={this.graphLayout} refilter={this.updateAfterFilterUpdate} getLastViewHist={this.getLastViewHist} handleDateStartChange={this.handleDateStartChange} handleDateEndChange={this.handleDateEndChange} updateRange={this.updateRange}/>}
				{[6].includes(this.state.view) && <AggGroupLayout state={this.state} groupChange={this.groupChange} refilter={this.updateAfterFilterUpdate}/>}
			</div>)}
			{!this.state.loggedIn && this.state.initAuth && (<div>
				Explorer authentication failed. Please screenshot this page and send it to support. Then completely log out of TRAC and log back in, which is a temporary fix for this problem.
			</div>)}
		</div>
		);
	}
}

export default App;
